// ========= START: src/components/BpEchoMainMenu.js (Complete File) =========
import React from 'react';

function BpEchoMainMenu({ onStartFreeChat, onConversationPractice }) {
  return (
    <div className="bp-echo-main-menu">
      <div className="menu-section">
        <h3>Free Chat</h3>
        <div className="menu-buttons-container">
          <button
            className="menu-button-image"
            onClick={() => onStartFreeChat('introductions')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/introductions-1.png")`
            }}
          >
            <span className="menu-button-label">Introductions</span>
          </button>
          <button
            className="menu-button-image"
            onClick={() => onStartFreeChat('likes-dislikes')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/likes_dislikes-1.png")`
            }}
          >
            <span className="menu-button-label">Likes & Dislikes</span>
          </button>
          <button
            className="menu-button-image"
            onClick={() => onStartFreeChat('hobbies')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/hobbies.png")`
            }}
          >
            <span className="menu-button-label">Hobbies</span>
          </button>
        </div>
      </div>
      
      <div className="menu-section">
        <h3>Conversation Practice</h3>
        <div className="menu-buttons-container">
          <button
            className="menu-button-image grade-button"
            onClick={() => onConversationPractice('grade5')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/grade_5.png")`
            }}
          >
            <span className="menu-button-label">Grade 5</span>
          </button>
          <button
            className="menu-button-image grade-button"
            onClick={() => onConversationPractice('grade6')}
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/assets/menu-buttons/topic-buttons/grade_6.png")`
            }}
          >
            <span className="menu-button-label">Grade 6</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default BpEchoMainMenu;
// ========= END: src/components/BpEchoMainMenu.js (Complete File) =========